import { Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Norpol.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class L1 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "l1";
    }
}

export function L1$reflection() {
    return class_type("Corpora.Norpol.MetadataCategories.L1", void 0, L1, Metadata_StringCategory$reflection());
}

export function L1_$ctor_Z721C83C5(aName) {
    return new L1(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.Norpol.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class Edu extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "edu";
    }
}

export function Edu$reflection() {
    return class_type("Corpora.Norpol.MetadataCategories.Edu", void 0, Edu, Metadata_StringCategory$reflection());
}

export function Edu_$ctor_Z721C83C5(aName) {
    return new Edu(aName);
}

export class Genre extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "genre";
    }
}

export function Genre$reflection() {
    return class_type("Corpora.Norpol.MetadataCategories.Genre", void 0, Genre, Metadata_StringCategory$reflection());
}

export function Genre_$ctor_Z721C83C5(aName) {
    return new Genre(aName);
}

export class Env extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "env";
    }
}

export function Env$reflection() {
    return class_type("Corpora.Norpol.MetadataCategories.Env", void 0, Env, Metadata_StringCategory$reflection());
}

export function Env_$ctor_Z721C83C5(aName) {
    return new Env(aName);
}

